<template>
  <div
    aria-labelledby="myModalLabel"
    data-backdrop="static"
    class="modal fade"
    id="send"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">发布</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="prompt">
              <i class="ti-link"></i>
              可以将云盘中文件发布出去，让其他主页能够使用它们。
            </div>
            <div class="form-group">
              <input
                class="form-control"
                name="link_title"
                v-model="form.link_title"
                placeholder="名称"
                type="text"
                data-vv-as="名称 "
                v-validate="{ required: true, min: 1, max: 100 }"
              />
              <span class="help-block" v-show="errors.has('link_title')">{{
                errors.first("link_title")
              }}</span>
            </div>
            <div class="form-group">
              选择文件夹或文件（已选择{{ form.resource_list.length }}个）
            </div>
            <div class="file-move">
              <div
                class="treeview"
                id="treeview-link"
                style="height: 250px"
              ></div>
            </div>
          </div>
          <div
            aria-controls="collapseSend"
            aria-expanded="true"
            class="form-group"
            data-toggle="collapse"
            href="#collapseSend"
            @click="setStrategy"
          >
            设置策略
            <i
              :class="{ 'ti-angle-up': strategy, 'ti-angle-down': !strategy }"
            ></i>
          </div>
          <div class="share-tactics collapse in" id="collapseSend">
            <div class="form-group">
              <div class="input-group">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group">
                      <input
                        class="form-control"
                        placeholder="密码保护"
                        type="text"
                        v-model="form.password"
                        name="password"
                        data-vv-as="密码 "
                        v-validate="{ min: 4, max: 10 }"
                      />
                      <span class="input-group-btn">
                        <button
                          class="btn btn-link"
                          type="button"
                          @click="createPassword"
                        >
                          自动生成
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group" @click="getFormatDateFocus">
                      <input
                        class="form-control"
                        placeholder="有效期"
                        type="text"
                        v-model="form.date"
                        name="date"
                        data-vv-as="有效期 "
                        v-validate="'date_format:yyyy-MM-dd'"
                      />
                      <div class="input-group-addon">
                        <i class="ti-calendar"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="help-block" v-show="errors.has('password')">{{
                errors.first("password")
              }}</span>
              <span class="help-block" v-show="errors.has('date')">{{
                errors.first("date")
              }}</span>
            </div>

            <div class="form-group">
              <div class="share-user">
                <div class="list" v-for="(ip, index) in form.ips" :key="ip">
                  <p>{{ ip }}</p>
                  <i
                    class="iconfont icon-close close"
                    @click="removeIp(index)"
                  ></i>
                </div>
                <input
                  type="text"
                  class="share-input"
                  v-model="ip"
                  placeholder="输入允许访问IP，按Enter添加"
                  @keyup.enter="addIp"
                  name="ip"
                  data-vv-as="IP "
                  v-validate="{}"
                />
              </div>
              <span class="help-block" v-show="errors.has('ip')">{{
                errors.first("ip")
              }}</span>
            </div>

            <!-- <div class="form-group">
              <div class="share-user">
                <div class="list" v-for="(url, index) in form.hosts" :key="url">
                  <p>{{url}}</p>
                  <i class="iconfont icon-close close" @click="removeUrl(index)"></i>
                </div>
                <input
                  type="text"
                  class="share-input"
                  v-model="host"
                  placeholder="输入允许请求域，按Enter添加"
                  @keyup.enter="addUrl"
                  name="host"
                  data-vv-as="域名 "
                  v-validate="{ regex: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/ }"
                />
              </div>
              <span class="help-block" v-show="errors.has('host')">{{ errors.first('host') }}</span>
            </div>-->
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-primary" type="button" @click="createLink">
            发布
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPublicFileInfo } from "@/api/drive/drive";
import { link } from "@/api/share/share";
import { getFormatDate, formatData } from "@/utils/index";
export default {
  name: "TableSend",
  data() {
    return {
      strategy: true,
      form: {
        link_title: "",
        password: null,
        date: null,
        ips: [],
        hosts: [],
        resource_list: [],
      },
      host: null,
      ip: null,
    };
  },
  created() {
    this.groupNumber = this.$route.params.groupNumber;
  },
  methods: {
    setStrategy() {
      this.strategy = !this.strategy;
    },
    clearForm() {
      this.form.link_title = "";
      this.form.password = "";
      this.form.date = "";
      this.form.ips = [];
      this.form.hosts = [];
      this.form.resource_list = [];
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    createLink() {
      this.$validator.validate().then((valid) => {
        if (valid || !this.strategy) {
          if (!this.form.resource_list.length) {
            this.$message({
              type: "warning",
              message: "请选择目标文件夹或文件",
            });
            return false;
          }
          let params = {
            group_number: this.groupNumber,
            link_title: this.form.link_title,
            resource_list: this.form.resource_list,
          };
          if (this.strategy) {
            params.link_constraint = {
              ip: this.form.ips,
              host: this.form.hosts,
              date: this.form.date ? this.form.date : null,
              password: this.form.password ? this.form.password : null,
            };
          }
          link(params)
            .then((res) => {
              if (res.status_code === 200) {
                $("#send").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.clearForm();
                this.$emit("refresh");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
    addUrl() {
      if (this.errors.has("host")) {
        return false;
      }
      if (this.host && this.form.hosts.indexOf(this.host) < 0) {
        this.form.hosts.push(this.host);
        this.host = "";
      } else if (this.host && this.form.hosts.indexOf(this.host) > -1) {
        this.errors.add({
          field: "host",
          msg: "域名 已存在，请勿重复添加",
        });
      }
    },
    removeUrl(index) {
      this.form.hosts.splice(index, 1);
    },
    addIp() {
      if (this.errors.has("ip")) {
        return false;
      }
      if (this.ip && this.form.ips.indexOf(this.ip) < 0) {
        this.form.ips.push(this.ip);
        this.ip = "";
      } else if (this.ip && this.form.ips.indexOf(this.ip) > -1) {
        this.errors.add({
          field: "ip",
          msg: "IP 已存在，请勿重复添加",
        });
      }
    },
    removeIp(index) {
      this.form.ips.splice(index, 1);
    },
    createPassword() {
      let password = Math.random().toString(36).substr(2, 4);
      this.form.password = password;
    },
    getFormatDateFocus(event) {
      $(event.currentTarget)
        .find("input:first-child")
        .datetimepicker({
          format: "yyyy-mm-dd",
          weekStart: 1,
          autoclose: true,
          startView: 2,
          minView: 2,
          pickerPosition: "bottom-right",
          language: "zh-CN",
          startDate: getFormatDate(),
        })
        .datetimepicker("show")
        .on("changeDate", (ev) => {
          this.form.date = getFormatDate(ev.date.valueOf());
        })
        .on("hide", (ev) => {
          $(ev.currentTarget).datetimepicker("remove");
        });
    },
    // 树形资源列表懒加载
    getChildNodes(node) {
      getPublicFileInfo({
        group_number: this.groupNumber,
        number: node.number,
        is_rec: false,
        category: "all",
        disk_type: "cloud",
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.total) {
              let nodes = res.entity.datas.map((item) => {
                return {
                  number: item.number,
                  type: item.type,
                  text: formatData(item),
                  icon:
                    item.type === "file"
                      ? "iconfont icon-file"
                      : "iconfont icon-folder",
                  tags: [],
                  selectable: true,
                  nodes: item.type === "file" ? null : [],
                };
              });
              $("#treeview-link").treeview("addNodes", [
                node.nodeId,
                {
                  nodes: nodes,
                },
              ]);
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取给定Node的所有父级NodeId集合
    getAllParentNode(node) {
      let parentNode = $("#treeview-link").treeview("getParent", node);
      if (parentNode.nodeId) {
        this.parentNodes.push(parentNode);
        this.getAllParentNode(parentNode);
      }
    },
    // 获取首层树列表
    getLinkTree() {
      let that = this;
      getPublicFileInfo({
        group_number: this.groupNumber,
        number: 0,
        is_rec: false,
        category: "all",
        disk_type: "cloud",
      })
        .then((res) => {
          this.form.resource_list = [];
          let tree = res.entity.datas.map((item) => {
            return {
              number: item.number,
              type: item.type,
              text: formatData(item),
              icon:
                item.type === "file"
                  ? "iconfont icon-file"
                  : "iconfont icon-folder",
              selectable: true,
              tags: [],
              nodes: item.type === "file" ? null : [],
            };
          });
          $("#treeview-link").treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            multiSelect: true,
            selectedBackColor: "#e6e6e6",
            showTags: true,
            onNodeExpanded: function (event, node) {
              if (!node.nodes.length) {
                that.getChildNodes(node);
              }
            },
            onNodeSelected: function (event, node) {
              // if (node.selectable) {
              that.form.resource_list.push(node.number);
              // 去除展开按钮，去除所有子级（让子级全部不能选）
              $("#treeview-link").treeview("setExpandedIconStatus", [
                node.nodeId,
                { expandedIconStatus: null, expanded: false },
              ]);
              // 让所有父级不可选
              that.parentNodes = [];
              that.getAllParentNode(node);
              $("#treeview-link").treeview("setNodesSelectedStatus", [
                { nodes: that.parentNodes, status: true },
              ]);
              // }
            },
            onNodeUnselected: function (event, node) {
              that.form.resource_list = that.form.resource_list.filter(
                (item) => item !== node.number
              );
              // 添加展开按钮（让子级可选）
              $("#treeview-link").treeview("setExpandedIconStatus", [
                node.nodeId,
                {
                  expandedIconStatus: node.type === "file" ? null : [],
                  expanded: false,
                },
              ]);
              // 让所有父级可选
              that.parentNodes = [];
              that.getAllParentNode(node);
              $("#treeview-link").treeview("setNodesSelectedStatus", [
                { nodes: that.parentNodes, status: false },
              ]);
            },
            data: tree,
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted: function () {
    let that = this;
    $("#send").on("shown.bs.modal", function (e) {
      that.getLinkTree();
    });
  },
  destroyed() {
    $("#send").off();
  },
};
</script>

<style scoped>
</style>